<div class="recipes-container">
    <mat-card appearance="outlined" class="type" *ngFor="let type of recipes">
        <mat-card-title class="card-title">{{ type.name }}</mat-card-title>
        <mat-card-content>
            <div class="recipes" *ngFor="let recipe of type.recipes" [routerLink]="['/recipe', recipe.id]">
                {{ recipe.title }}
            </div>
        </mat-card-content>
    </mat-card>
</div>